<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName }}</p>
    </div>
    <osp-table [tblConfig]="srcExtTblConfig" (onRowClick)="onRowClick($event)" ></osp-table>
    <div class="form-container" id="src-ext-maintenance-loading">
        <div class="form-loader"></div>
    </div>
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.srcExtForm" class="form">
            <div id="src-ext-error-message"></div>
            <div class="form-container-grid">
                <div class="field">
                    <label>Source Extension Code</label>
                </div>
                <div class="">
                    <input formControlName="srcExtCdDisp" >
                </div>
                <div class="field required">
                    <label>Active</label>
                </div>
                <div class="">
                    <select formControlName="active">
                        <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                            {{activeType.name}}
                        </option>
                    </select>
                </div>
                <div class="field required">
                    <label>Source Extension</label>
                </div>
                <div class="span">
                    <input formControlName="srcExtDesc" maxlength="100">
                </div>
                <div class="field">
                    <label>Issue Source</label>
                </div>
                <div class="">
                    <input formControlName="issDisp" readonly>
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov.iss()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <div class="field">
                    <label>BMA</label>
                </div>
                <div class="">
                    <input formControlName="bmaDisp" readonly>
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov.bma()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <div class="field">
                    <label>Branch Code</label>
                </div>
                <div class="">
                    <input formControlName="brCode" maxlength="10">
                </div>
                <div class="field required">
                    <label>BPIMS Code</label>
                </div>
                <div class="">
                    <input formControlName="bmCode" maxlength="8" >
                </div>
                <div class="field">
                    <label>Remarks</label>
                </div>
                <div class="span">
                    <input formControlName="remarks" maxlength="4000" >
                </div>
                <div class="field">
                    <label>Last Update User</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdateUser" >
                </div>
                <div class="field">
                    <label>Last Update</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdate" >
                </div>
            </div>
        </form>
        <div class="btn-grp">
            <button *ngIf="btns.srcExt.updateDisabled" class="btn btn2" type="button" (click)="onAdd()">ADD</button>
            <button *ngIf="!btns.srcExt.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()">UPDATE</button>
            <button class="btn btn2" type="button" [disabled]='btns.srcExt.deleteDisabled' (click)="onDelete()">DELETE</button>
        </div>
        <div class="mtn-title"></div>
        <div class="btn-grp">
            <button class="btn btn2" type="button" [disabled]='btns.srcExt.saveDisabled' (click)="onSave()">SAVE</button>
        </div>
    </div>
</div>